export default __webpack_public_path__ + "static/media/photo1.caafac1d.svg";